import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ResponseService } from 'src/app/core/models/response-service.model';
import { UtilsService } from '../utils/utils.service';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CalendarService {
	private campaignInfoCache = new Map<string, any>();
	constructor(private http: HttpClient, private utils: UtilsService) {}

	getCampaignMonthLeads(payload: any) {
		const url = `${environment.api}calendar/get_campaign_month_leads`;
		const formData = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	public get_calendar_leads_by_user(userId: number, dateStart: string, dateEnd: string) {
		if (dateStart == '') {
			dateStart = '-';
		}
		if (dateEnd == '') {
			dateEnd = '-';
		}

		return this.http.get(`${environment.api}lead/get_calendar_leads_user/${userId}/${dateStart}/${dateEnd}`);
	}

	getApprovedUnreviewedLeads(alias: any, campaignId: any): Observable<any> {
		const formData: FormData = new FormData();
		formData.append('alias', alias);
		formData.append('campaignId', campaignId);

		const url: string = `${environment.api}lead/get_approved_unreviewed_leads`;
		return this.http.post(url, formData);
	}

	getCachedCampaignInfo(key: string) {
		return this.campaignInfoCache.get(key);
	}

	setCachedCampaignInfo(key: string, data: any) {
		this.campaignInfoCache.set(key, data);
	}
}
